import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig, GroupConfigs} from '../../../shared/models/config';
import {Observable, Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../reducers';
import * as fromShared from '../../../shared/reducers';
import {GetFormsService} from '../../../shared/services/get-forms.service';
import {skipWhile} from 'rxjs/operators';
import {Site} from '../../../shared/models/site';
import {LoadDeviceAvailableAction} from '../../../shared/actions/device-available';
import {GetConfigSiteService} from '../../services/get-config-site.service';
import {SiteAssignPlayerAction} from '../../actions/site-assign-player';
import {Client, WarningToastAction} from '../../../shared';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {LoadClientConfigurationAction} from '../../../shared/actions/client-configuration';
import {LoadPlayerAdoptionFamiliesAction} from '../../../order/actions/player-adoption-families';
import * as fromOrders from '../../../order/reducers';
import {AssignAdoptionPlayerAction, AssignAdoptionSubscriptionPlayerAction} from '../../../order/actions/assign-adoption-player';
import {Concept, ConceptOrder} from '../../../shared/models/concept';
import * as fromOrder from '../../../order/reducers';
import {LoadConceptOrderAction} from '../../../order/actions/order-dxp-concept-load';
import {LoadConceptsAction} from '../../../shared/actions/concept';
import {LoadConceptAction} from '../../actions/concept-subcription-load';
import {GetConfigOrderService} from '../../../order/services/get-config-order.service';

@Component({
  selector: 'storever-site-add-player',
  templateUrl: './site-add-player.component.html',
  styleUrls: ['./site-add-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteAddPlayerComponent  implements OnInit, OnChanges, OnDestroy {

  @ViewChild('staticModal' , {static: false}) public staticModal: ModalDirective;
  @Input() selectedItemUuid: string;
  client$: Observable<Client>;
  site$: Observable<Site>;
  concepts$: Observable<Concept[]>;
  site: Site;
  myForm: FormGroup;
  form: FormGroup;
  formAdoption: FormGroup;
  formConfigAdoption: GroupConfig;
  conceptForm: FormGroup;
  conceptFormConfig: GroupConfig;
  isMaestroClientConfiguration = false;
  formConfig: GroupConfigs;
  // tslint:disable-next-line:no-any
  productId: any;
  isDXP = false;
  currentClient: Client;
  private sub$: Subscription;
  private subscriptions = [];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private translation: L10nTranslationService,
              private storeSite: Store<fromSites.AppState>,
              private store: Store<fromOrders.AppState>,
              private cdr: ChangeDetectorRef,
              private getConfigOrder: GetConfigOrderService,
              private storeShared: Store<fromShared.AppState>,
              private getConfigSiteService: GetConfigSiteService,
              private formsService: GetFormsService) {
  }

  ngOnInit(): void {
    this.myForm = this.formsService.getSiteAssignPlayer();
    this.formConfig = this.getConfigSiteService.getPlayersAddConfigs();
    this.formAdoption = this.formsService.getAssignAdoptionPlayer();
    this.formConfigAdoption = this.getConfigSiteService.getConfigAddPlayerFamilies();
    this.conceptForm = this.formsService.getConceptsPlayer();
    this.conceptFormConfig = this.getConfigOrder.getConfigConceptsPlayer();
    this.client$ = this.storeSite.pipe(select(fromShared.selectors.getCurrentClient));
    this.site$ = this.storeSite.pipe(select(fromSites.selectors.getSite));
    this.client$.subscribe((client: Client) => {
      if (client) {
        this.currentClient = client;
      }
    })
    this.sub$ = this.storeSite.pipe(
      select(fromSites.selectors.getSite),
      skipWhile((site: Site) => !site)
    ).subscribe((site: Site) => {
      if (site && site.subscriptions && this.currentClient) {

        if (site.subscriptions[0].cmsServerID && site.subscriptions[0].cmsServerID.toLowerCase().search('dxp') !== -1) {
          this.isDXP = true;
          this.store.dispatch(new LoadPlayerAdoptionFamiliesAction( {productID: site.subscriptions[0].product.id , client: this.currentClient.uuid} ));
          this.productId = site.subscriptions[0].product.id;
          this.store.dispatch(new LoadConceptAction({
            siteUuid : site.uuid ,
            subscriptionUuid : site.subscriptions[0].uuid
          }));
          this.storeShared.dispatch(new LoadConceptsAction(this.currentClient.uuid));
        } else {
          this.isDXP = false;
          this.storeSite.dispatch(new LoadDeviceAvailableAction(site.subscriptions[0].product.id));
        }
        this.productId = site.subscriptions[0].product.id;
        this.cdr.detectChanges();

        if (this.productId  === 27) {
          this.formConfigAdoption = this.getConfigSiteService.getConfigAddPlayerFamiliesWithBritgh();
          this.formAdoption.get(['bsnProductModel' , 'name']).setValidators([Validators.required]);
          this.formAdoption.get(['bsnProductModel' , 'name']).updateValueAndValidity();
          this.formAdoption.get(['familiesName' , 'name']).patchValue('Brightsign');
          this.formConfigAdoption.config[1].label = 'GENERIC_SERIAL_NUMBER';
          this.formConfigAdoption.config[1].placeholder = 'GENERIC_SERIAL_NUMBER';
        } else {
          this.formConfigAdoption = this.getConfigSiteService.getConfigAddPlayerFamilies();
          this.formAdoption.get(['bsnProductModel' , 'name']).setValidators([]);
          this.formAdoption.get(['bsnProductModel' , 'name']).updateValueAndValidity();
          this.formConfigAdoption.config[1].label = 'GENERIC_ADOPTION_CODE';
          this.formConfigAdoption.config[1].placeholder = 'GENERIC_ADOPTION_CODE';
        }
        if ( this.productId  === 24) {
          this.formAdoption.get(['familiesName' , 'name']).patchValue('Linux');
        }
      }
    });

    this.subscriptions.push(this.sub$);
    this.site$.subscribe((site: Site) => {
      if (site) {
        this.site = site;
        }

    })

    this.concepts$ = this.storeSite.pipe(select(fromSites.selectors.getConceptsBySubscription));
    this.concepts$.subscribe(data => {
      const conceptsIds  = [];
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          conceptsIds.push(data[i].id)
        }
        this.formAdoption.get(['concepts', 'id']).patchValue(conceptsIds)
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItemUuid && changes.selectedItemUuid.currentValue) {

    }
  }

  // tslint:disable-next-line:no-any
  send(value: string , adoptionValues: any): void {
    if (adoptionValues.code) {
      this.store.dispatch(new AssignAdoptionSubscriptionPlayerAction({
        subscriptionUuid: this.site.subscriptions[0].uuid,
        code: adoptionValues.code,
        concepts: adoptionValues.concepts.id,
        isDefault: adoptionValues.isDefault,
        bsnProductModel: adoptionValues.bsnProductModel.name,
        family: adoptionValues.familiesName.name.toLowerCase() }));
    } else {
      if (this.isDXP) {
      this.storeSite.dispatch(new SiteAssignPlayerAction({
        'deviceID': this.myForm.get('id').value,
        'isDefault': this.myForm.get('isDefault').value,
        concepts: this.conceptForm.get(['concepts' , 'id']).value}));
    } else {
        this.storeSite.dispatch(new SiteAssignPlayerAction({
          'deviceID': this.myForm.get('id').value,
          'isDefault': this.myForm.get('isDefault').value,
          concepts: null}));
      }
    }
    this.close();
  }

  close(): void {
    this.myForm.reset();
    // this.productId = null;
    this.staticModal.hide();
  }

  open(message: string): void {
    if (this.productId && this.productId  === 24) {
      this.formAdoption.get(['familiesName' , 'name']).patchValue('Linux');
    }
    if (this.productId && this.productId  === 27) {
      this.formAdoption.get(['familiesName' , 'name']).patchValue('Brightsign');
    }
    if (message) {
      this.dispatchWarningToast(message);
    } else {
      this.staticModal.show();
    }
  }

  dispatchWarningToast(message: string): void {
    this.storeSite.dispatch(new WarningToastAction({
      message: this.translation.translate(message),
      title: 'WARNING'
    }));
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }
}
